import { BreadcrumbsState } from "@gumtree/shared/src/model/breadcrumbs.model";

const initialState: BreadcrumbsState = {
    links: [],
};

export const UPDATE_BREADCRUMBS = 'UPDATE_BREADCRUMBS';

export const updateBreadcrumbs = (payload) => ({
    type: UPDATE_BREADCRUMBS,
    payload,
});

export default (state = initialState, action): BreadcrumbsState =>
    action.type === UPDATE_BREADCRUMBS ? { ...state, ...action.payload } : state;
